import { Card, Modal } from 'antd'
import styled from 'styled-components'

export const DataSelectionCardStyled = styled(Card)`
  margin-bottom: 16px;
  border-radius: 8px;

  .ant-card-head {
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
  }
`

export const TransferSection = styled.div`
  margin-bottom: 24px;
`

export const TransferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #e8e8e8;
`

export const LimitModal = styled(Modal)`
  && {
    .ant-modal-content {
      box-shadow: none;
    }
    .ant-modal-header {
      margin-bottom: 16px;
    }
    .ant-alert-content {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }
`

export const AttentionModal = styled(Modal)`
  && {
    .ant-modal-content {
      box-shadow: none;
    }
    .ant-modal-header {
      margin-bottom: 16px;
    }
  }
`
